import { useState, useCallback } from 'react';
import { loadTheme, saveTheme } from '../utils/storage';

/**
 * Custom hook for managing theme state
 * @returns {Object} - Theme state and toggle function
 */
export const useTheme = () => {
  const [isDarkTheme, setIsDarkTheme] = useState(() => loadTheme());

  const toggleTheme = useCallback(() => {
    setIsDarkTheme(prev => {
      const newValue = !prev;
      saveTheme(newValue);
      return newValue;
    });
  }, []);

  return {
    isDarkTheme,
    toggleTheme,
    themeClass: isDarkTheme ? '' : 'light-theme',
  };
};
